import { render, staticRenderFns } from "./refundRecord.vue?vue&type=template&id=ad50dba2&scoped=true&"
import script from "./refundRecord.vue?vue&type=script&lang=js&"
export * from "./refundRecord.vue?vue&type=script&lang=js&"
import style0 from "./refundRecord.vue?vue&type=style&index=0&id=ad50dba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad50dba2",
  null
  
)

export default component.exports